<template>
  <div class="con-wrap">
    <div class="top" @click="changeTab">
      <div class="top-nav">
        <div class="scroll-item">
          <!-- <div class="top-active-bar" :style="'width:'+width+'px';"></div> -->
          <div class="text" :class="!activeName ? 'scroll-active' : ''">
            <div class="one">欧诺S（1.0版）</div>
          </div>
          <div class="text" :class="activeName ? 'scroll-active' : ''">
            <div class="two">长安睿行EM80（2.0版）</div>
          </div>
        </div>
      </div>
    </div>
    <el-row class="bottom-page">
      <div class="bottom-content">
        <el-form
          size="medium"
          :inline="true"
          :model="queryForm"
          ref="queryForm"
          class="input-form-inline"
          @submit.native.prevent
        >
          <div>
            <el-form-item class="r-20" prop="plate">
              <el-input
                v-model.trim="queryForm.plate"
                @keyup.enter.native="query"
                placeholder="车牌号"
              ></el-input>
            </el-form-item>
            <el-form-item class="r-20" prop="vin">
              <el-input
                v-model.trim="queryForm.vin"
                @keyup.enter.native="query"
                placeholder="车架号"
              ></el-input>
            </el-form-item>
            <el-form-item class="r-20" prop="personnelName">
              <el-input
                v-model.trim="queryForm.personnelName"
                @keyup.enter.native="query"
                placeholder="车辆绑定人"
              ></el-input>
            </el-form-item>
            <el-form-item class="r-20" prop="deviceId">
              <el-input
                v-model.trim="queryForm.deviceId"
                @keyup.enter.native="query"
                placeholder="设备编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="r-20"
              prop="propertyOwner"
              style="margin-right: 40px"
            >
              <el-select
                v-model="queryForm.propertyOwner"
                placeholder="请选择产权方"
              >
                <el-option
                  v-for="item in ownershipName"
                  :key="item.id"
                  :label="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="r-20"
              prop="deptIds"
              style="margin-right: 40px"
            >
              <el-cascader
                v-model="queryForm.deptIds"
                style="width: 260px"
                size="mini"
                placeholder="部门"
                :options="deptTreeData"
                :props="{
                  emitPath: false,
                  multiple: true,
                  checkStrictly: true,
                  value: 'id',
                }"
                :show-all-levels="false"
                clearable
                collapse-tags
              >
              </el-cascader>
            </el-form-item>
            <!-- <el-form-item class="r-20" prop="version">
              <el-select
                v-model.trim="queryForm.version"
                placeholder="车辆型号"
              >
                <el-option
                  v-for="item in vehicleModelList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-button
              v-if="hasPerm('vehicle:list')"
              type="primary"
              @click="query"
              >查询</el-button
            >
            <el-button v-if="hasPerm('vehicle:list')" @click="reset"
              >取消</el-button
            >
          </div>

          <div style="margin-bottom: 20px">
            <el-button
              v-if="hasPerm('vehicle:save')"
              type="primary"
              @click="addVehicle"
              >新增</el-button
            >
            <el-button
              size="medium"
              v-if="hasPerm('vehicle:delete')"
              type="danger"
              @click.native="delVehicle"
              >删除</el-button
            >
            <el-button
              v-if="hasPerm('vehicle:template')"
              type="primary"
              @click="TemplateDownload"
              >模板下载</el-button
            >
            <el-button
              v-if="hasPerm('vehicle:import')"
              type="primary"
              @click="clickBatchImport"
              >批量导入</el-button
            >
            <el-button
              v-if="hasPerm('vehicle:untie')"
              type="warning"
              @click="unbundlingOwner"
              >解绑车主</el-button
            >
            <el-button
              style="width: 105px"
              v-if="hasPerm('vehicle:stat:contrast')"
              type="primary"
              @click="dataComparing"
              >数据统计对比</el-button
            >
            <el-button
              style="width: 105px"
              type="primary"
              v-if="hasPerm('vehicle:correct:maintain:mileage')"
              @click="maintainBtn"
              >保养里程校准</el-button
            >
            <el-button
              style="width: 105px"
              v-if="hasPerm('vehicle:dynamo:func')"
              type="primary"
              @click="powerSwitch"
              >发电服务开关</el-button
            >
            <el-button
              style="width: 105px"
              v-if="hasPerm('vehicle:export')"
              type="primary"
              @click="exportData"
              >导出Excel</el-button
            >
          </div>
        </el-form>
        <el-table
          :loading="loading"
          ref="doLayout"
          :key="activeName"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          stripe
          height="560px"
          @row-click="handleClickTableRow"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="24"
            align="center"
            style="padding: 0"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="35"
          ></el-table-column>
          <el-table-column
            prop="vin"
            label="车架号"
            width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="propertyOwner"
            width="100"
            label="产权方"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="companyName"
            label="使用公司"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="deptName"
            label="使用部门"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            prop="vehicleModel"
            label="车辆型号"
            min-width="170px"
          >
            <template slot="header">
              <span>车辆型号</span>
              <span
                @click="vehicleModelChange"
                class="iconfont icon-sort"
              ></span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="personnelName"
            label="车辆绑定人"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="plateNum" label="车牌号" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                style="cursor: pointer; color: #0094ff"
                @click="gotoMonitor(scope.row)"
                >{{ scope.row.plateNum }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceId"
            label="设备编号"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="onlineStatus"
            label="车辆状态"
            min-width="90px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.onlineStatus == 1" class="btn-red"
                >待命</span
              >
              <span v-else-if="scope.row.onlineStatus == 2" class="btn-green"
                >在线</span
              >
            </template>
            <template slot="header">
              <span>车辆状态</span>
              <span
                @click="vehicleStatusChange"
                class="iconfont icon-sort"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="powerStatus" label="发电状态" min-width="90px">
            <template slot-scope="scope">
              <span v-if="scope.row.powerStatus == 0" class="btn-red"
                >未发电</span
              >
              <span v-else-if="scope.row.powerStatus == 1" class="btn-green"
                >发电中</span
              >
              <span v-else></span>
            </template>
            <template slot="header">
              <span>发电状态</span>
              <span
                @click="powerStatusChange"
                class="iconfont icon-sort"
              ></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="cutOffTime"
            label="发电服务关闭时间"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.cutOffTime == '发电服务已关闭'"
                style="color: #f00"
                >{{ scope.row.cutOffTime }}</span
              >
              <span v-else>{{ scope.row.cutOffTime }}</span>
            </template>
          </el-table-column>
          <!-- 1.0车辆显示总里程 -->
          <el-table-column
            v-if="!activeName"
            prop="electricityTotalMileage"
            width="100"
            label="总里程(公里)"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            v-if="activeName"
            prop="electricityTotalMileage"
            width="150"
            label="增程器使用里程(公里)"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            v-if="!activeName"
            prop="mileage"
            width="150"
            label="剩余保养里程(km)"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :class="classChange(scope.row.mileage)">{{
                scope.row.mileage
              }}</span>
            </template>
            <template slot="header">
              <span>剩余保养里程(km)</span>
              <span @click="mileageChange" class="iconfont icon-sort"></span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="!activeName"
            prop="gearbox"
            width="190"
            label="变速箱剩余保养里程(km)"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.gearbox == ''">-</span>
              <span v-else :class="classGearboxChange(scope.row.gearbox)">{{
                scope.row.gearbox
              }}</span>
            </template>
            <template slot="header">
              <span>变速箱剩余保养里程(km)</span>
              <span @click="gearboxChange" class="iconfont icon-sort"></span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeName"
            prop="rangeExtender"
            width="190"
            label="增程器剩余保养里程(km)"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rangeExtender == ''">-</span>
              <span v-else :class="classChange(scope.row.rangeExtender)">{{
                scope.row.rangeExtender
              }}</span>
            </template>
            <template slot="header">
              <span>增程器剩余保养里程(km)</span>
              <span
                @click="rangeExtenderChange('rangeExtender')"
                class="iconfont icon-sort"
              ></span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="!activeName"
            prop="powerTakeoff"
            width="200"
            label="取力器剩余保养里程(km)"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.powerTakeoff == ''">-</span>
              <span
                v-else
                :class="classGearboxChange(scope.row.powerTakeoff)"
                >{{ scope.row.powerTakeoff }}</span
              >
            </template>
            <template slot="header">
              <span>取力器剩余保养里程(km)</span>
              <span
                @click="powerTakeoffChange"
                class="iconfont icon-sort"
              ></span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeName"
            prop="rearAxleDifferential"
            width="230"
            label="后桥差速器剩余保养里程(km)"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rearAxleDifferential == ''">-</span>
              <span
                v-else
                :class="classChange(scope.row.rearAxleDifferential)"
                >{{ scope.row.rearAxleDifferential }}</span
              >
            </template>
            <template slot="header">
              <span>后桥差速器剩余保养里程(km)</span>
              <span
                @click="rearAxleDifferentialChange"
                class="iconfont icon-sort"
              ></span>
            </template>
          </el-table-column>
          <el-table-column
            label="距下次年检截止"
            min-width="180"
            prop="remainDays"
          >
            <template slot="header">
              <span>距下次年检截止（天）</span>
              <i class="iconfont icon-sort" @click="annualSurveyFilter"></i>
            </template>
            <template slot-scope="scope">
              <span :class="classRemain(scope.row.remainDays)">{{
                scope.row.remainDays
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="330" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-if="
                  hasPerm('vehicle:details:status,vehicle:details:basic:info')
                "
                @click.stop="getUserInfo(scope.row)"
                style="margin-left: 10px"
                >车辆详情</el-button
              >
              <el-button
                size="mini"
                type="text"
                v-if="hasPerm('vehicle:repair:reset')"
                @click.stop="resetMileage(scope.row)"
                >重置保养里程</el-button
              >
              <el-button
                size="mini"
                type="text"
                v-if="hasPerm('vehicle:viewDocumentsD')"
                @click.stop="queryDriver(scope.row)"
                style="margin-left: 10px"
                >查看行驶证</el-button
              >
              <el-button
                size="mini"
                type="text"
                v-if="hasPerm('vehicle:viewDocuments')"
                @click.stop="queryElectrician(scope.row)"
                style="margin-left: 10px"
                >电工证</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        <!-- 保养里程校准 -->
        <el-dialog
          title="保养里程校准"
          :visible.sync="maintainVisible"
          class="mini-dialog powerDialog"
        >
          <el-row class="desc">
            <p>
              设置说明：剩余保养里程校准后将在车辆“保养记录”里生成一条新的记录。
            </p>
          </el-row>
          <el-row class="maintainDesc" style="margin-top: 15px !important">
            <el-col :span="6">当前剩余保养里程：</el-col>
            <el-col :span="8">{{ maintainMileage }}km</el-col>
          </el-row>
          <el-row class="maintainDesc">
            <el-col :span="4">校准里程：</el-col>
            <el-col :span="8">
              <el-input
                placeholder="请输入实际里程数"
                size="small"
                v-model="mileage"
              >
              </el-input>
            </el-col>
            km
          </el-row>
          <el-row class="maintainDesc">
            <el-col :span="4">校准发电量：</el-col>
            <el-col :span="8">
              <el-input
                placeholder="请输入实际发电量"
                size="small"
                v-model="energy"
              >
              </el-input>
            </el-col>
            kW·h
          </el-row>
          <!-- <el-row class="maintainDesc" style="margin-top: 15px !important">
        <el-col :span="8">当前剩余变速箱保养里程：</el-col>
        <el-col :span="8">{{ maintainGearbox }}km</el-col>
      </el-row>
      <el-row class="maintainDesc">
        <el-col :span="3">校准里程：</el-col>
        <el-col :span="8">
          <el-input
            size="small"
            v-model.trim="gearbox"
            placeholder="请输入实际剩余保养里程数"
          >
          </el-input>
        </el-col>
        km
      </el-row>
      <el-row class="maintainDesc" style="margin-top: 15px !important">
        <el-col :span="8">当前剩余取力器保养里程：</el-col>
        <el-col :span="8">{{ maintainPowerTakeoff }}km</el-col>
      </el-row>
      <el-row class="maintainDesc">
        <el-col :span="3">校准里程：</el-col>
        <el-col :span="8">
          <el-input
            size="small"
            v-model="powerTakeofff"
            placeholder="请输入实际剩余保养里程数"
          >
          </el-input>
        </el-col>
        km
      </el-row> -->

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="maintainCommit"
              >确认修改</el-button
            >
            <el-button class="btn" @click="maintainVisible = false"
              >取 消</el-button
            >
          </span>
        </el-dialog>
        <!-- 发电功能 -->
        <el-dialog
          title="发电功能"
          :visible.sync="powerVisible"
          class="mini-dialog powerDialog"
        >
          <el-row class="desc">
            <p v-if="openPower">
              设置说明：选择对应时间代表开启发电后，发电功能的剩余使用时间（到期时间），到期后系统会自动发送关闭车辆发电服务指令。
            </p>
            <p v-else>
              设置说明：选择“立即关闭”系统将会直接发送关闭车辆发电服务指令；选择自定义时间，系统将会在时间到期后自动发送关闭车辆发电服务指令。
            </p>
          </el-row>
          <p class="powerTitle">{{ openPower ? "开启" : "关闭" }}发电功能</p>
          <el-row>
            <el-radio-group v-model="powerParams.type" size="small">
              <el-radio-button
                label="1"
                v-if="!openPower"
                @click.native="customizeTime = false"
                >立即关闭</el-radio-button
              >
              <el-radio-button
                label="3"
                v-if="openPower"
                @click.native="customizeTime = false"
                >24小时</el-radio-button
              >
              <el-radio-button
                label="4"
                v-if="openPower"
                @click.native="customizeTime = false"
                >48小时</el-radio-button
              >
              <el-radio-button label="2" @click.native="customizeTime = true"
                >自定义</el-radio-button
              >
            </el-radio-group>
            <el-date-picker
              v-if="customizeTime"
              size="small"
              v-model="powerParams.time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :picker-options="expireTimeOption"
              placeholder="选择时间"
            >
            </el-date-picker>
          </el-row>
          <template v-if="openPower">
            <p class="powerTitle">选择场景</p>
            <el-row>
              <el-radio-group v-model="powerParams.scene" size="small">
                <el-radio-button label="3">应急抢险救灾</el-radio-button>
                <el-radio-button label="1">发电功能开启异常</el-radio-button>
                <el-radio-button label="2">测试发电功能</el-radio-button>
              </el-radio-group>
            </el-row>
          </template>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="powerCommit">确认修改</el-button>
            <el-button class="btn" @click="powerVisible = false"
              >取 消</el-button
            >
          </span>
        </el-dialog>
        <!-- 数据统计对比 -->
        <el-dialog
          title="数据统计对比"
          class="dataCompare"
          width="1570px"
          :stripe="true"
          @close="dataCompareClose"
          :visible.sync="dataVisible"
        >
          <el-row style="margin-bottom: 20px !important">
            <span style="color: #333">查询时间：</span>
            <el-date-picker
              v-model="dataParams.date"
              size="small"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <span style="margin-left: 20px; color: #333">数据截取时间：</span>
            <el-time-picker
              is-range
              size="small"
              v-model="dataParams.time"
              value-format="HH:mm:ss"
              :default-value="[
                new Date(2016, 9, 10, 0, 0, 0),
                new Date(2016, 9, 10, 23, 59, 59),
              ]"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-time-picker>
            <el-button
              size="medium"
              type="primary"
              style="margin-left: 20px"
              @click.native="getdataComparing"
              >查询</el-button
            >
            <el-button
              size="medium"
              @click.native="
                dataParams.date = '';
                dataParams.time = ['', ''];
              "
              >取消</el-button
            >
          </el-row>
          <el-row>
            <el-table
              ref="dataTable"
              :data="comparingData"
              height="500px"
              tooltip-effect="dark"
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="45"
              ></el-table-column>
              <el-table-column
                prop="vin"
                label="车架号"
                width="170"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="name"
                width="80"
                label="车辆绑定人"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="plateNumber"
                label="车牌号"
                width="90"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    style="cursor: pointer; color: #0094ff"
                    @click="gotoMonitor(scope.row)"
                    >{{ scope.row.plateNumber }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="countMileage"
                sortable
                label="总里程(km)"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dynamoMileage"
                sortable
                label="发电里程(km)"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="drivingMileage"
                sortable
                label="行驶里程(km)"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="drivingDuration"
                label="行驶时长"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dynamoCapacity"
                sortable
                label="发电量(kW·h)"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dynamoDuration"
                sortable
                label="发电时长"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="dynamoOil"
                sortable
                label="发电油耗(L)"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="drivingOil"
                sortable
                label="行驶油耗(L)"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="avgRespTime"
                sortable
                label="平均响应时长"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    v-if="
                      hasPerm(
                        'vehicle:details:status,vehicle:details:basic:info'
                      )
                    "
                    @click.stop="getUserInfo(scope.row)"
                    >车辆详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-dialog>
        <!--新增车辆-->
        <el-dialog
          title="新增车辆"
          :visible.sync="addVehicleVisible"
          class="vehicle-dialog"
        >
          <el-form
            :rules="vehicleRules"
            ref="vehicleForm"
            :model="vehicleForm"
            size="mini"
            :inline="true"
          >
            <el-form-item prop="vehicleModelId" label="车辆型号">
              <el-select
                v-model="vehicleForm.vehicleModelId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in modelList"
                  :key="item.id"
                  :label="item.vehicleModel"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="vin" label="车架号">
              <el-input
                v-model="vehicleForm.vin"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item prop="engineCode" label="发动机编号">
              <el-input
                v-model="vehicleForm.engineCode"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item prop="vehicleDate" label="生产日期">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="vehicleForm.vehicleDate"
                type="date"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addVehicleVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 批量导入 -->
        <el-dialog
          title="基站批量导入"
          :visible.sync="importVisible"
          class="mini-dialog"
        >
          <el-form
            :rules="modelRules"
            ref="importForm"
            :model="importForm"
            size="mini"
            :inline="true"
          >
            <el-form-item prop="modelId" label="车辆型号">
              <el-select v-model="importForm.modelId" placeholder="请选择">
                <el-option
                  v-for="item in modelList"
                  :key="item.id"
                  :label="item.vehicleModel"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="upload-box" label="文件名">
              <el-upload
                class="upload-demo"
                ref="upload"
                :with-credentials="true"
                :multiple="false"
                :limit="1"
                accept=".xls, .xlsx"
                :data="myData()"
                :file-list="fileList"
                :on-change="addFile"
                :action="uploadUrl()"
                :http-request="uploadSectionFile"
                :auto-upload="false"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button class="btn" @click="importVisible = false"
              >取 消</el-button
            >
            <el-button type="primary" @click="importCommit">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 重置保养里程 -->
        <el-dialog
          title="重置保养里程"
          class="mini-dialog"
          :visible.sync="dialogVisible"
        >
          <div>请选择你想要重置的项目</div>
          <div
            style="margin-top: 20px"
            class="maintainRest"
            v-show="!activeName"
          >
            <el-checkbox
              v-model="powerTakeoffReset"
              @change="powerReset"
              :false-label="1"
              :true-label="2"
              >重置取力器保养里程</el-checkbox
            >
            <el-checkbox
              v-model="gearboxReset"
              @change="gearReset"
              :false-label="1"
              :true-label="2"
              >重置变速箱保养里程</el-checkbox
            >
            <el-checkbox
              v-model="maintainLimitReset"
              :false-label="1"
              :true-label="2"
              >重置车辆保养里程</el-checkbox
            >
            <el-checkbox
              v-model="powerTakeoffReplace"
              @change="powerChange"
              :false-label="1"
              :true-label="2"
              >更换取力器</el-checkbox
            >
            <el-checkbox
              v-model="gearboxReplace"
              @change="gearChange"
              :false-label="1"
              :true-label="2"
              >更换变速箱</el-checkbox
            >
          </div>
          <div
            style="margin-top: 20px"
            class="maintainRest-two"
            v-show="activeName"
          >
            <el-checkbox
              v-model="rangeExtenderReset"
              @change="rangeReset"
              :false-label="1"
              :true-label="2"
              >重置增程器保养里程</el-checkbox
            >
            <el-checkbox
              v-model="rearAxleDifferentialReset"
              @change="rearAxleReset"
              :false-label="1"
              :true-label="2"
              >重置后桥差速器保养里程</el-checkbox
            >
            <el-checkbox
              v-model="rangeExtenderReplace"
              @change="rangeChange"
              :false-label="1"
              :true-label="2"
              >更换增程器</el-checkbox
            >
            <el-checkbox
              v-model="rearAxleDifferentialReplace"
              @change="rearAxleChange"
              :false-label="1"
              :true-label="2"
              >更换后桥差速器</el-checkbox
            >
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="resetMileageConfirm()"
              >确 定</el-button
            >
          </span>
        </el-dialog>
        <!-- 行驶证/电工证弹窗 -->
        <el-dialog
          :title="certificateTitle"
          :visible.sync="certificateVisibility"
          class="mini-dialog driverBody"
        >
          <template v-if="certificateTitle == '行驶证'">
            <p class="dialog-title">车辆照片页</p>
            <div v-if="vehicleUrl == ''" class="noImageWrap">
              未上传
            </div>
            <div class="imgWrap" style="padding-bottom: 10px" v-else>
              <el-image
                style="width: 440px; height: 280px"
                :src="vehicleUrl"
                :preview-src-list="vehicleUrlList"
              >
              </el-image>
            </div>
          </template>
          <p class="dialog-title">{{ certificateTitle }}主页</p>
          <div
            v-if="mainPageUrl == '' && electricianUrl == ''"
            class="noImageWrap"
          >
            未上传
          </div>
          <div class="imgWrap" style="padding-bottom: 10px" v-else>
            <el-image
              style="width: 440px; height: 280px"
              :src="mainPageUrl || electricianUrl"
              :preview-src-list="mainPageUrlList || electricianUrlList"
            >
            </el-image>
          </div>
          <p class="dialog-title">{{ certificateTitle }}副页</p>
          <div
            v-if="vicePageUrl == '' && viceElectricianUrl == ''"
            class="noImageWrap"
          >
            未上传
          </div>
          <div class="imgWrap" v-else>
            <el-image
              style="width: 440px; height: 280px"
              :src="vicePageUrl || viceElectricianUrl"
              :preview-src-list="vicePageUrlList || viceElectricianUrlList"
            >
            </el-image>
          </div>
        </el-dialog>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      width: 0,
      activeName: false,
      version: 1,
      loading: false,
      certificateTitle: "",
      driverVisible: false,
      vehicleUrl: "",
      mainPageUrl: "",
      vicePageUrl: "",
      vehicleUrlList: [],
      mainPageUrlList: [],
      vicePageUrlList: [],
      electricianVisible: false,
      electricianUrl: "",
      viceElectricianUrl: "",
      electricianUrlList: [],
      viceElectricianUrlList: [],
      deptTreeData: [],
      dialogVisible: false,
      resetMileageId: null,
      maintainLimitReset: 1,
      powerTakeoffReset: 1,
      gearboxReset: 1,
      powerTakeoffReplace: 1,
      gearboxReplace: 1,
      rangeExtenderReset: 1,
      rearAxleDifferentialReset: 1,
      rangeExtenderReplace: 1,
      rearAxleDifferentialReplace: 1,
      maintainVisible: false,
      maintainMileage: null,
      maintainEnergy: null,
      mileage: null,
      energy: null,
      timer: null,
      dataVisible: false,
      dataParams: {
        date: "",
        time: "",
      },
      comparingData: [],
      powerTime: null,
      powerVisible: false,
      customizeTime: false,
      openPower: true,
      powerParams: {
        type: null,
        vin: null,
        time: null,
        scene: null,
      },
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000; //当天可选
          // return date.getTime() < Date.now() //当天不可选
        },
      },
      queryForm: {
        vin: "",
        plate: "",
        deviceId: "",
        deptIds: [],
        personnelName: "",
        version: "",
        propertyOwner: "",
      },
      onlineStatus: "",
      checkRemind: "",
      powerStatus: "",
      annualSurvey: "",
      vinBind: "",
      deviceBind: "",
      mileageSort: "1",
      gearboxSort: "",
      powerTakeoff: "",
      rangeExtender: "1",
      rearAxleDifferential: 0,
      limit: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      tableVal: [],
      addVehicleVisible: false,
      modelList: [],
      vehicleForm: {
        vehicleModelId: "",
        vin: "",
        engineCode: "",
        vehicleDate: "",
      },
      vehicleRules: {
        vehicleModelId: [
          {
            required: true,
            trigger: "change",
            message: "请选择车辆型号",
          },
        ],
        vin: [
          {
            required: true,
            trigger: "change",
            message: "请输入车架号",
          },
          {
            required: true,
            pattern: this.$formRules.vin,
            message: this.$formRules.vinMsg,
            trigger: "blur",
          },
        ],
        engineCode: [
          {
            required: true,
            trigger: "change",
            message: "请输入发动机编号",
          },
        ],
        vehicleDate: [
          {
            required: true,
            trigger: "change",
            message: "请选择车辆生产日期",
          },
        ],
      },
      modelRules: {
        modelId: [
          {
            required: true,
            trigger: "change",
            message: "请选择车辆型号",
          },
        ],
      },
      importVisible: false,
      fileList: [],
      fileSizeIsSatisfy: false,
      importForm: {
        modelId: "",
      },
      extension: "",
      upload: "",
      ownershipName: {},
      restaurants: {},
    };
  },
  computed: {
    // 监听驾驶证或者电工证弹框打开和关闭
    certificateVisibility: {
      get() {
        return this.driverVisible || this.electricianVisible;
      },
      set(value) {
        this.driverVisible = value;
        this.electricianVisible = value;
      },
    },
  },
  created() {
    let id = this.$route.params.id;
    let version = this.$route.params.version;
    let isAllNewVersion = this.$route.params.isAllNewVersion;
    let obj = this.$store.state.VehicleFormData.form_data;
    let tag = Object.keys(obj);
    if (tag.length > 0) {
      this.queryForm = { ...obj };
    }
    if (isAllNewVersion || version == 2) {
      // 通知父组件tab切换到2.0车辆页数据
      this.activeName = true;
    } else {
      this.activeName = false;
    }
    if (this.$route.params.currentPage) {
      this.currentPage = parseInt(this.$route.params.currentPage);
      this.queryForm.plate = sessionStorage.getItem("vehiclePlate");
      this.queryForm.vin = sessionStorage.getItem("vehiclevin");
    }
    sessionStorage.setItem("vehicleStatus", id);
    if (id == 3) {
      this.powerStatus = 1;
    } else {
      this.powerStatus = "";
      this.onlineStatus = id == "undefined" ? "" : id;
    }
    this.getVehicleList();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/VehicleInfo") {
      let path = from.path; //path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
      sessionStorage.setItem("pathUrl", path);
    }
    next();
  },
  mounted() {
    this.getDeptList();
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.getVehicleList();
    }, 1000 * 20);
    this.getModelList();
    this.dataVisible =
      sessionStorage.getItem("dataVisible") == "true" ? true : false;
    if (this.dataVisible) {
      this.dataParams = {
        date: sessionStorage.getItem("dataCompareDate").split(","),
        time: sessionStorage.getItem("dataCompareTime").split(","),
      };
      this.getdataComparing();
    }
    this.getOwnerNameList();
  },
  methods: {
    // 获取产权方名称列表
    async getOwnerNameList() {
      let { data: res } = await this.$axios.get(
        "/api/property/management/getName"
      );
      if (res.code == 1) {
        this.ownershipName = res.data.map((item, index) => {
          return { id: index, value: item };
        });
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 切换按钮事件
    changeTab(e) {
      if (e.target.className == "two") {
        this.activeName = true;
        this.version = 2;
      } else if (e.target.className == "one") {
        this.activeName = false;
        this.version = 1;
      } else {
        return;
      }
      this.getVehicleList();
      this.$nextTick(() => {
        this.$refs.doLayout.doLayout();
      });
    },
    //查询电工证
    async queryElectrician(rowData) {
      if (!rowData.personnelId) {
        this.$message.warning("未绑定运维人员");
        return;
      }
      let _this = this;
      // 先清除驾驶证数据
      _this.vehicleUrl = "";
      _this.mainPageUrl = "";
      _this.vicePageUrl = "";
      _this.vehicleUrlList = [];
      _this.mainPageUrlList = [];
      _this.vicePageUrlList = [];
      let id = rowData.personnelId;
      _this.electricianVisible = true;
      _this.certificateTitle = "电工证";
      _this.electricianUrl = "";
      _this.viceElectricianUrl = "";
      _this.electricianUrlList = [];
      _this.viceElectricianUrlList = [];
      let { data: res } = await _this.$axios.get(
        "/api/sys/image/list?belongType=5&belongId=" + id
      );
      if (res.code == 1) {
        let arr = res.data;
        for (let item in arr) {
          if (arr[item].imageType == 2) {
            // 主页数据
            _this.electricianUrl = arr[item].url;
            _this.electricianUrlList.push(_this.electricianUrl);
            _this.mainPageUrlList.push(_this.electricianUrl);
          } else if (arr[item].imageType == 3) {
            // 副页数据
            _this.viceElectricianUrl = arr[item].url;
            _this.viceElectricianUrlList.push(_this.viceElectricianUrl);
            _this.vicePageUrlList.push(_this.viceElectricianUrl);
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //查询行驶证
    async queryDriver(rowData) {
      let _this = this;
      // 先清除电工证数据
      _this.electricianUrl = "";
      _this.viceElectricianUrl = "";
      _this.electricianUrlList = [];
      _this.viceElectricianUrlList = [];
      let id = rowData.personnelId;
      _this.certificateTitle = "行驶证";
      _this.vehicleUrl = "";
      _this.mainPageUrl = "";
      _this.vicePageUrl = "";
      _this.vehicleUrlList = [];
      _this.mainPageUrlList = [];
      _this.vicePageUrlList = [];
      _this.driverVisible = true;
      let { data: res } = await _this.$axios.get("/api/vehicle/driving/" + id);
      if (res.code == 1) {
        let arr = res.data;
        arr.forEach((item) => {
          if (item.belongType == 2) {
            // 筛选出行驶证的数据
            if (item.imageType == 2) {
              // 主页数据
              _this.mainPageUrl = item.url;
              _this.mainPageUrlList.push(_this.mainPageUrl);
            } else if (item.imageType == 3) {
              // 副页数据
              _this.vicePageUrl = item.url;
              _this.vicePageUrlList.push(_this.vicePageUrl);
            } else if (item.imageType == 1) {
              // 车辆照片页数据
              _this.vehicleUrl = item.url;
              _this.vehicleUrlList.push(_this.vehicleUrl);
            }
          }
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getDeptList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        _this.deptTreeData = res.data;
        //_this.deptId = res.data[0].id
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //数据导出
    exportData() {
      let _this = this;
      _this
        .$confirm("确定导出当前查询数据吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
        .then(async () => {
          let obj = {};
          let url = "";
          obj.plate = _this.queryForm.plate;
          obj.vin = _this.queryForm.vin;
          obj.version = _this.version;
          obj.propertyOwner = _this.queryForm.propertyOwner;
          if (_this.onlineStatus == undefined) {
            _this.onlineStatus = "";
          }
          obj.onlineStatus = _this.onlineStatus;
          obj.powerStatus = _this.powerStatus;
          obj.mileageSort = _this.mileageSort;
          obj.powerTakeoff = _this.powerTakeoff;
          obj.gearboxSort = _this.gearboxSort;
          obj.checkRemind = _this.checkRemind;
          obj.personnelName = _this.queryForm.personnelName;
          obj.rearAxleDifferential = _this.rearAxleDifferential;
          obj.rangeExtender = _this.rangeExtender;
          obj.deviceId = _this.queryForm.deviceId;
          obj.deptIds = _this.queryForm.deptIds.join(", ");
          if (_this.version == 2) {
            // 2.0车辆数据
            url =
              "/api/vehicle/list/V2/export?plate=" +
              obj.plate +
              "&vin=" +
              obj.vin +
              "&propertyOwner=" +
              obj.propertyOwner +
              "&personnelName=" +
              obj.personnelName +
              "&rangeExtender=" +
              obj.rangeExtender +
              "&rearAxleDifferential=" +
              obj.rearAxleDifferential +
              "&version=" +
              obj.version +
              "&onlineStatus=" +
              obj.onlineStatus +
              "&powerStatus=" +
              obj.powerStatus +
              "&checkRemind=" +
              obj.checkRemind +
              "&deviceId=" +
              obj.deviceId +
              "&deptIds=" +
              obj.deptIds;
          } else {
            // 1.0车辆数据
            url =
              "/api/vehicle/list/V2/export?plate=" +
              obj.plate +
              "&vin=" +
              obj.vin +
              "&propertyOwner=" +
              obj.propertyOwner +
              "&personnelName=" +
              obj.personnelName +
              "&rangeExtender=" +
              obj.rangeExtender +
              "&rearAxleDifferential=" +
              obj.rearAxleDifferential +
              "&version=" +
              obj.version +
              "&onlineStatus=" +
              obj.onlineStatus +
              "&powerStatus=" +
              obj.powerStatus +
              "&mileageSort=" +
              obj.mileageSort +
              "&powerTakeoff=" +
              obj.powerTakeoff +
              "&gearboxSort=" +
              obj.gearboxSort +
              "&checkRemind=" +
              obj.checkRemind +
              "&deviceId=" +
              obj.deviceId +
              "&deptIds=" +
              obj.deptIds;
          }
          window.location.href = url;
        });
    },
    powerReset() {
      this.powerTakeoffReplace =
        this.powerTakeoffReset == 2 ? 1 : this.powerTakeoffReplace;
    },
    powerChange() {
      this.powerTakeoffReset =
        this.powerTakeoffReplace == 2 ? 1 : this.powerTakeoffReset;
    },
    gearReset() {
      this.gearboxReplace = this.gearboxReset == 2 ? 1 : this.gearboxReplace;
    },
    gearChange() {
      this.gearboxReset = this.gearboxReplace == 2 ? 1 : this.gearboxReset;
    },
    // 重置和更换项目是互斥的，不能同时选中
    rangeReset() {
      this.rangeExtenderReplace =
        this.rangeExtenderReset == 2 ? 1 : this.rangeExtenderReplace;
    },
    rearAxleReset() {
      this.rearAxleDifferentialReplace =
        this.rearAxleDifferentialReset == 2
          ? 1
          : this.rearAxleDifferentialReplace;
    },
    rearAxleChange() {
      this.rearAxleDifferentialReset =
        this.rearAxleDifferentialReplace == 2
          ? 1
          : this.rearAxleDifferentialReset;
    },
    rangeChange() {
      this.rangeExtenderReset =
        this.rangeExtenderReplace == 2 ? 1 : this.rangeExtenderReset;
    },
    // 跳转至运行监控
    gotoMonitor(rowData) {
      console.log(rowData);
      sessionStorage.setItem("monitorLnglat", rowData.lnglat);
      sessionStorage.setItem("isSearch", true);
      sessionStorage.setItem(
        "fullMonitorPlate",
        rowData.plateNum || rowData.plateNumber
      );
      const { href } = this.$router.resolve({
        path: "/fullScreenMonitor",
      });
      window.open(href, "_blank");
    },
    dataCompareClose() {
      sessionStorage.setItem("dataVisible", false);
    },
    // 数据统计对比
    dataComparing() {
      this.getdataComparing();
      this.dataParams = {
        date: "",
        time: "",
      };
      sessionStorage.setItem("dataVisible", true);
      this.dataVisible = true;
    },
    // 查询数据对比项
    async getdataComparing() {
      let _this = this;
      let startDate = this.dataParams.date[0] || "";
      let endDate = this.dataParams.date[1] || "";
      let startTime = this.dataParams.time[0] || "";
      let endTime = this.dataParams.time[1] || "";
      sessionStorage.setItem("dataCompareDate", this.dataParams.date);
      sessionStorage.setItem("dataCompareTime", this.dataParams.time);
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/stat/contrast?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&startTime=" +
          startTime +
          "&endTime=" +
          endTime
      );
      if (res.code == 1) {
        _this.comparingData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 保养里程校准
    maintainBtn() {
      this.mileage = null;
      this.energy = null;
      let length = this.tableVal.length;
      if (!length) {
        this.$message.warning("请选择一条数据");
        return;
      } else if (length > 1) {
        this.$message.warning("只能选择一条数据");
        return;
      } else {
        console.log(this.tableVal[0]);
        this.maintainMileage = this.tableVal[0].mileage;
        this.maintainEnergy = this.tableVal[0].energy;
        this.maintainVisible = true;
      }
    },
    async maintainCommit() {
      let _this = this;
      let data = this.tableVal[0];
      console.log(data);
      let obj = {
        mileage: this.mileage,
        energy: this.energy,
        vin: data.vin,
      };
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/correct/maintain/mileage",
        obj
      );
      if (res.code == 1) {
        _this.$message.success("修改成功");
        _this.getVehicleList();
        _this.maintainVisible = false;
      } else {
        _this.$message.warning(res.msg);
        _this.maintainVisible = false;
      }
    },
    // 发电功能
    powerSwitch() {
      let length = this.tableVal.length;
      if (!length) {
        this.$message.warning("请选择一条数据");
        return;
      } else if (length > 1) {
        this.$message.warning("只能选择一条数据");
        return;
      } else {
        let obj = this.tableVal[0];
        let switchBtn = obj.dynamoFunc;
        this.powerParams.vin = obj.vin;
        this.customizeTime = false;
        this.powerParams.type = null;
        this.powerParams.scene = null;
        if (!switchBtn) {
          //开启发电
          this.openPower = true;
        } else {
          //关闭发电
          this.openPower = false;
        }
        this.powerVisible = true;
      }
    },
    // 确认修改发电功能
    async powerCommit() {
      if (!this.powerParams.type) {
        this.$message.warning("请选择时间");
        return;
      } else if (this.powerParams.type != 2) {
        this.powerParams.time = "";
      } else if (this.powerParams.type == 2 && !this.powerParams.time) {
        this.$message.warning("请选择自定义时间");
        return;
      }
      let _this = this;
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/dynamo/func",
        this.powerParams
      );
      if (res.code == 1) {
        _this.$message.success("修改成功");
        _this.getVehicleList();
        _this.powerVisible = false;
      } else {
        _this.$message.warning(res.msg);
        _this.getVehicleList();
      }
    },
    async getVehicleList() {
      let _this = this;
      let obj = {};
      _this.loading = true;
      obj.vin = _this.queryForm.vin;
      obj.plate = _this.queryForm.plate;
      obj.personnelName = _this.queryForm.personnelName;
      obj.deviceId = _this.queryForm.deviceId;
      obj.deptIds = _this.queryForm.deptIds.toString();
      obj.propertyOwner = _this.queryForm.propertyOwner;
      if (_this.activeName) {
        // 2.0车辆数据
        obj.version = 2;
        obj.rearAxleDifferential = _this.rearAxleDifferential;
        obj.rangeExtender = _this.rangeExtender;
        obj.mileageSort = "";
        obj.gearboxSort = "";
        obj.powerTakeoff = "";
      } else {
        // 1.0车辆数据
        obj.version = 1;
        obj.rearAxleDifferential = 0;
        obj.rangeExtender = 0;
        obj.mileageSort = _this.mileageSort;
        obj.gearboxSort = _this.gearboxSort;
        obj.powerTakeoff = _this.powerTakeoff;
      }
      obj.powerStatus = _this.powerStatus;
      obj.onlineStatus = _this.onlineStatus;
      obj.checkRemind = _this.checkRemind;
      obj.personnelBind = _this.vinBind;
      obj.deviceBind = _this.deviceBind;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get("/api/vehicle/list/V2", {
        params: obj,
      });
      if (res.code == 1) {
        _this.loading = false;
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
        _this.currentPage = res.data.currPage;
      }
    },
    query() {
      this.getVehicleList().then(() => {
        if (!(this.tableData.length > 0)) {
          this.activeName = !this.activeName;
          this.getVehicleList();
        }
      });
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.queryForm.vin = "";
      this.queryForm.plate = "";
      this.queryForm.personnelName = "";
      this.queryForm.propertyOwner = "";
      this.queryForm.version = "";
      this.queryForm.deviceId = "";
      this.queryForm.deptIds = [];
      this.vinBind = "";
      this.deviceBind = "";
      this.version = "";
      this.powerStatus = "";
      this.onlineStatus = "";
      this.remainDays = "";
      this.gearboxSort = "";
      this.powerTakeoff = "";
      this.mileageSort = "1";
      // 增程器、后桥差速器默认值为0要求不能为空
      this.rearAxleDifferential = 0;
      this.rangeExtender = 0;
      this.getVehicleList();
    },
    addVehicle() {
      this.$resetForm(this, "vehicleForm");
      this.vehicleForm.vehicleModelId = "";
      this.addVehicleVisible = true;
    },
    async getModelList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/vehicle/model/options");
      if (res.code == 1) {
        _this.modelList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    saveOrUpdate() {
      let _this = this;
      _this.$refs.vehicleForm.validate(async (valid) => {
        if (valid) {
          let { data: res } = await _this.$axios.post(
            "/api/vehicle",
            _this.vehicleForm
          );
          if (res.code == 1) {
            _this.addVehicleVisible = false;
            _this.$resetForm(_this, "vehicleForm");
            _this.getVehicleList();
            _this.$message.success("操作成功");
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    async delVehicle() {
      let _this = this;
      //多选删除
      let ids = _this.$getIds(_this.tableVal);
      if (!ids) {
        return;
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/vehicle", {
            data: JSON.stringify(ids),
          });
          if (res.code == 1) {
            _this.$message.success("操作成功");
            let totalPage = Math.ceil((_this.total - 1) / 10);
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage;
            _this.currentPage = currentPage < 1 ? 1 : currentPage;
            _this.getVehicleList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    // 模板下载
    TemplateDownload() {
      this.$confirm("确定下载该模板吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.location.href = "/api/vehicle/template";
      });
    },
    // 批量导入-start-
    clickBatchImport() {
      this.$resetForm(this, "importForm");
      this.fileList = [];
      this.importVisible = true;
    },
    myData() {
      return {
        id: this.importForm.modelId,
      };
    },
    addFile(file, fileList) {
      this.fileList = fileList;
      //限制上传文件为5M
      this.fileSizeIsSatisfy = file.size < 5 * 1024 * 1024 ? true : false;
      this.extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(file.type);
    },
    uploadUrl() {
      return "/api/vehicle/import";
    },
    async uploadSectionFile(parm) {
      let _this = this;
      let fileObj = parm.file;
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("id", _this.importForm.modelId);
      let { data: res } = await _this.$axios.post("/api/vehicle/import", form);
      if (res.code == 1) {
        _this.$message.success("导入成功");
        _this.importVisible = false;
        //导入成功后清空upload
        _this.$refs.upload.clearFiles();
        _this.fileList = [];
        _this.getVehicleList();
      } else {
        _this.$refs.upload.clearFiles();
        _this.fileList = [];
        _this.$message.warning(res.msg);
      }
    },
    async importCommit() {
      this.$refs.importForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length <= 0) {
            this.$message.warning("请至少上传一个文件！");
            return;
          }
          if (this.extension !== "xlsx" && this.extension !== "xls") {
            this.$message.warning("上传失败！请上传excel表格文件！");
            this.$refs.upload.clearFiles();
            this.fileList = [];
            return;
          }
          if (!this.fileSizeIsSatisfy) {
            this.$message.warning("上传失败！文件大小超过5M！");
            this.$refs.upload.clearFiles();
            this.fileList = [];
            return;
          }
          this.$refs.upload.submit();
        }
      });
    },
    //解绑车主
    unbundlingOwner() {
      let _this = this;
      let val = this.tableVal;
      for (let i = 0; i < val.length; i++) {
        if (val[i].personnelBind == 1) {
          this.$message.warning("未绑定车主不可进行解绑操作！");
          return;
        }
      }
      let orderIds = this.$getIds(val);
      if (orderIds) {
        _this
          .$confirm("是否确认解绑车主？", "提示信息", {
            confirmButtonText: "确认解绑",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(async () => {
            let { data: res } = await _this.$axios.patch(
              "/api/vehicle/untie",
              orderIds
            );
            if (res.code == 1) {
              _this.$message.success("操作成功");
              _this.getVehicleList();
            } else {
              _this.$message.warning(res.msg);
            }
          });
      }
    },
    // 批量导入-end-
    personnelBindChange() {
      console.log("personnelBindChange");
      this.vinBind = this.vinBind == 1 ? 2 : 1;
      this.onlineStatus = "";
      this.remainDays = "";
      this.powerStatus = "";
      this.deviceBind = "";
      this.gearboxSort = "";
      this.powerTakeoff = "";
      this.mileageSort = "";
      this.getVehicleList();
    },
    deviceBindChange() {
      console.log("deviceBindChange");
      this.deviceBind = this.deviceBind == 1 ? 2 : 1;
      this.onlineStatus = "";
      this.remainDays = "";
      this.powerStatus = "";
      this.vinBind = "";
      this.gearboxSort = "";
      this.powerTakeoff = "";
      this.mileageSort = "";
      this.getVehicleList();
    },
    vehicleStatusChange() {
      console.log("vehicleStatusChange");
      this.onlineStatus = this.onlineStatus == 1 ? 2 : 1;
      this.remainDays = "";
      this.powerStatus = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.gearboxSort = "";
      this.powerTakeoff = "";
      this.mileageSort = "";
      this.getVehicleList();
    },
    powerStatusChange() {
      console.log("powerStatusChange");
      this.powerStatus = this.powerStatus == 1 ? 0 : 1;
      this.onlineStatus = "";
      this.remainDays = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.gearboxSort = "";
      this.powerTakeoff = "";
      this.mileageSort = "";
      this.getVehicleList();
    },
    mileageChange() {
      console.log("mileageChange");
      this.powerStatus = "";
      this.onlineStatus = "";
      this.remainDays = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.gearboxSort = "";
      this.powerTakeoff = "";
      this.mileageSort = this.mileageSort == 1 ? 2 : 1;
      this.getVehicleList();
    },
    gearboxChange() {
      console.log("gearboxChange");
      this.powerStatus = "";
      this.onlineStatus = "";
      this.remainDays = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.mileageSort = "";
      this.powerTakeoff = "";
      this.gearboxSort = this.gearboxSort == 1 ? 2 : 1;
      this.getVehicleList();
    },
    rangeExtenderChange() {
      console.log("rangeExtenderChange");
      this.powerStatus = "";
      this.onlineStatus = "";
      this.remainDays = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.rearAxleDifferential = 0;
      this.rangeExtender = this.rangeExtender == 1 ? 2 : 1;
      this.getVehicleList();
    },
    rearAxleDifferentialChange() {
      console.log("rearAxleDifferentialChange");
      this.powerStatus = "";
      this.onlineStatus = "";
      this.remainDays = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.rangeExtender = 0;
      this.rearAxleDifferential = this.rearAxleDifferential == 1 ? 2 : 1;
      console.log(this.rearAxleDifferential);
      this.getVehicleList();
    },
    powerTakeoffChange() {
      console.log("powerTakeoffChange");
      this.powerStatus = "";
      this.onlineStatus = "";
      this.remainDays = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.mileageSort = "";
      this.gearboxSort = "";
      this.powerTakeoff = this.powerTakeoff == 1 ? 2 : 1;
      this.getVehicleList();
    },
    annualSurveyFilter() {
      console.log("annualSurveyFilter");
      this.powerStatus = "";
      this.powerTakeoff = "";
      this.onlineStatus = "";
      this.deviceBind = "";
      this.vinBind = "";
      this.mileageSort = "";
      this.gearboxSort = "";
      this.checkRemind = this.checkRemind == 1 ? 2 : 1;
      this.getVehicleList();
    },
    getUserInfo(rowData) {
      this.$router.push({
        name: "VehicleInfo",
        params: {
          vin: rowData.vin,
          id: rowData.id,
          version: rowData.version,
          active: "real",
        },
      });
      sessionStorage.setItem("vehicleCurrPage", this.currentPage);
      sessionStorage.setItem("vehiclePlate", this.queryForm.plate);
      sessionStorage.setItem("vehiclevin", this.queryForm.vin);
      // this.$router.push("/VehicleInfo/" + rowData.vin)
      //提交到store
      let version = rowData.version == "0A50" ? 2 : 1;
      this.$store.commit("setVersion", version);
      this.$store.commit("setFormData", this.queryForm);
    },
    resetMileage(rowData) {
      this.dialogVisible = true;
      if (this.activeName) {
        this.rangeExtenderReset = 1;
        this.rearAxleDifferentialReset = 1;
        this.rangeExtenderReplace = 1;
        this.rearAxleDifferentialReplace = 1;
      } else {
        this.maintainLimitReset = 1;
        this.powerTakeoffReset = 1;
        this.gearboxReset = 1;
        this.powerTakeoffReplace = 1;
        this.gearboxReplace = 1;
      }
      this.resetMileageId = rowData.id;
    },
    async resetMileageConfirm() {
      let _this = this;
      let version = _this.activeName ? 2 : 1;
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/reset?id=" +
          this.resetMileageId +
          "&maintainLimit=" +
          this.maintainLimitReset +
          "&powerTakeoff=" +
          this.powerTakeoffReset +
          "&gearbox=" +
          this.gearboxReset +
          "&powerTakeoffReplace=" +
          this.powerTakeoffReplace +
          "&gearboxReplace=" +
          this.gearboxReplace +
          "&rangeExtender=" +
          this.rangeExtenderReset +
          "&rearAxleDifferential=" +
          this.rearAxleDifferentialReset +
          "&rangeExtenderReplace=" +
          this.rangeExtenderReplace +
          "&rearAxleDifferentialReplace=" +
          this.rearAxleDifferentialReplace +
          "&version=" +
          version
      );
      if (res.code == 1) {
        _this.getVehicleList();
        _this.$message.success("重置成功");
        _this.dialogVisible = false;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    handleClickTableRow(row, event, column) {
      console.log(column);
      this.$refs.doLayout.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getVehicleList();
    },
    classChange(val) {
      if (val > 1000 && val <= 1500) {
        return "warningBg warning1";
      } else if (val <= 1000 && val > 500) {
        return "warningBg warning2";
      } else if (val <= 500 && val > 200) {
        return "warningBg warning3";
      } else if (val <= 200 && val > 0) {
        return "warningBg warning4";
      } else if (val === "") {
        return val;
      } else if (val <= 0) {
        return "warningBg warning5";
      }
    },
    classGearboxChange(val) {
      if (val <= 3000 && val > 1000) {
        return "warningBg warning3";
      } else if (val <= 1000 && val > 0) {
        return "warningBg warning4";
      } else if (val === "") {
        return val;
      } else if (val <= 0) {
        return "warningBg warning5";
      }
    },
    classRemain(val) {
      if (val <= 90 && val > 60) {
        return "warningBg remain-yellow";
      } else if (val <= 60 && val > 30) {
        return "warningBg remain-orange";
      } else if (val <= 30 && val > 0) {
        return "warningBg remain-red";
      } else if (val <= 0) {
        return "warningBg remain-dep-red";
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: calc(100% - 40px);
  overflow: auto;
  .top {
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px !important;
    background: #fff;
    .top-nav {
      overflow: hidden;
      margin-bottom: -1px;
      position: relative;
    }
    .top-nav:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #e4e7ed;
      z-index: 1;
    }
    .scroll-item {
      position: relative;
      display: inline-block;
      transition: transform 0.3s;
      .top-active-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        background-color: #409eff;
        z-index: 2;
        transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        list-style: none;
      }
      .text {
        position: relative;
        padding-left: 10px;
        margin: 0 20px;
        height: 40px;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        border-color: #e4e7ed;
        transition-property: color, border-color;
        transition-duration: 0.3s, 1s;
        transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
        &.scroll-active {
          color: #409eff;
          border-bottom: 2px solid;
          border-color: #409eff;
          padding-left: 10px;
          z-index: 2;
        }
      }
    }
  }
  .bottom-page {
    background: #fff;
    height: calc(100% - 60px);
    .bottom-content {
      margin: 20px;
      padding: 0 20px;
      /deep/ .el-table th > .cell {
        height: 23px;
      }
    }
  }
}
.count {
  font-size: 12px;
  margin-left: 10px;
  color: #333333;
}
.count_hide {
  visibility: hidden;
}

.maintainRest {
  /deep/ .el-checkbox {
    width: 150px;
    line-height: 28px;
  }
}
.noImageWrap {
  width: 440px;
  height: 40px;
  line-height: 40px;
  color: #ccc;
}
.remain-yellow {
  background: #e8d210;
}
.remain-orange {
  background: #ff9900;
}
.remain-red {
  background: #f00;
}
.remain-dep-red {
  background: #c00;
}
// 发电功能开启关闭弹窗
.powerDialog {
  .desc {
    font-size: 12px;
    line-height: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ee2121;
  }
  .powerTitle {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin: 10px 0px;
  }
  /deep/ .el-radio-button__inner {
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-right: 10px;
    box-shadow: none !important;
  }
  .maintainDesc {
    font-size: 14px;
    line-height: 45px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}

.dataCompare /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.dataCompare /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 4px;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  background: #999;
}
.dataCompare /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  background: #ededed;
}

.full-page {
  padding: 0 20px;
  background: #fff;
}
.upload-box /deep/ .el-form-item__label {
  padding-left: 11px;
  position: relative;
}
.upload-box /deep/ .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  position: absolute;
  left: 0px;
  top: 1px;
}
//新增弹窗
.vehicle-dialog /deep/ .el-dialog {
  width: 600px;
}
.vehicle-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.vehicle-dialog /deep/ .el-form-item__content {
  width: 360px;
  height: auto;
}
.vehicle-dialog /deep/ .el-form-item__content {
  width: 360px;
}
.vehicle-dialog /deep/ .el-date-editor.el-input {
  width: 360px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 260px;
}
.imgWrap {
  position: relative;
  margin-top: 20px;
  max-width: 500px;
  max-height: 340px;
  overflow-y: auto;
  overflow-x: hidden;
}
.imgWrap img {
  width: auto;
  height: 280px;
}
.driverBody /deep/ {
  .el-dialog {
    padding-bottom: 20px;
  }
  .el-dialog__body {
    max-height: 600px;
    overflow: auto;
  }
}
.warningBg {
  color: #fff;
  padding: 4px;
  border-radius: 4px;
}
/* 文字颜色 */
.warning1 {
  background-color: #e8d210;
}
.warning2 {
  background-color: #ffb505;
}
.warning3 {
  background-color: #ff7b05;
}
.warning4 {
  background-color: #ff3a05;
}
.warning5 {
  background-color: #840900;
}
</style>
